import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { LandingHomeComponent } from './modules/landing/home/home.component';
import { RedirectGuard } from './core/auth/guards/redirect.guard';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    // Redirect guard checking for any query params
    {
        path: '', 
        pathMatch : 'full', 
        canActivate: [RedirectGuard], 
        component: LandingHomeComponent
    },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: '/dashboard'},
 

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        data: {
            layout: 'enterprise'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            // {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')},
            {path: 'installation', loadChildren: () => import('app/modules/installation/installation.routes')},
            {path: 'accept-debit-order', loadChildren: () => import('app/modules/dashboard/debit-orders/accept-debit-order/accept-debit-order.routes')},
            {path: 'emandate', loadChildren: () => import('app/modules/order-process/emandate/emandate.routes')},
            {path: 'cart', loadChildren: () => import('app/modules/order-process/cart/cart.routes')},
            {path: 'credit-information', loadChildren: () => import('app/modules/order-process/credit-information/credit-information.routes')},
            {path: 'checkout', loadChildren: () => import('app/modules/order-process/checkout/checkout.routes')},
            {path: 'vetting-failed', loadChildren: () => import('app/modules/order-process/vetting-failed/vetting-failed.routes')},
            {path: 'vetting-referred', loadChildren: () => import('app/modules/order-process/vetting-referred/vetting-referred.routes')},
            {path: 'order-complete', loadChildren: () => import('app/modules/order-process/order-complete/order-complete.routes')},
            {path: 'tickets', loadChildren: () => import('app/modules/dashboard/tickets/tickets.routes')},
            {path: 'dashboard', loadChildren: () => import('app/modules/dashboard/dashboard.routes')},
            {path: 'dashboard/profile', loadChildren: () => import('app/modules/dashboard/profile/profile.routes')},
            {path: 'dashboard/services', loadChildren: () => import('app/modules/dashboard/my-services/my-services.routes')},
            {path: 'dashboard/requests', loadChildren: () => import('app/modules/dashboard/requests/requests.routes')},
            {path: 'dashboard/myinvoices', loadChildren: () => import('app/modules/dashboard/invoices/invoices.routes')},
            {path: 'dashboard/payment-details', loadChildren: () => import('app/modules/dashboard/payment-details/payment-details.routes')},
            {path: 'dashboard/myinvoices', loadChildren: () => import('app/modules/dashboard/invoices/invoices.routes')},
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        data: {
            layout: 'enterprise'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'verify', loadChildren: () => import('app/modules/sales-agent/verify-account/verify-account.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            // {path: 'forgot-username', loadChildren: () => import('app/modules/auth/forgot-username/forgot-username.routes')},
            {path: 'resend-registration-link', loadChildren: () => import('app/modules/auth/resend-registration-link/resend-registration-link.routes')},
            {path: 'reset', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')},
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},
            {path: 'packages', loadChildren: () => import('app/modules/order-process/packages/packages.routes')},
            {path: 'package-review', loadChildren: () => import('app/modules/order-process/package-review/package-review.routes')},
            {path: 'call-me-back', loadChildren: () => import('app/modules/order-process/call-me-back/call-me-back.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'register', loadChildren: () => import('app/modules/auth/register/register.routes')},
            {path: 'email-verify', loadChildren: () => import('app/modules/auth/email-verify/email-verify.routes')},
            {path: 'show-my-interest', loadChildren: () => import('app/modules/auth/showmyinterest/showmyinterest.routes')},
            {path: 'installation', loadChildren: () => import('app/modules/installation/installation.routes')},
            {path: 'pre-orders', loadChildren: () => import('app/modules/sales-agent/sales-agent.routes')},
            {path: 'pre-orders/create-password', loadChildren: () => import('app/modules/sales-agent/create-password/create-password.routes')},
            {path: 'contact', loadChildren: () => import('app/modules/contact-us/contact-us.routes')},
        ]
    }

]
